module.exports = __webpack_public_path__ + "img/SC10-Cover_Costs.e89ccf0b.svg";